import { useSiteContent } from '@/hooks/useSiteContent';
import ContentState from '@/components/feature/ContentState';

interface ThreeThingsData {
  title: string;
  highlight: string;
  titleEnd: string;
  items: { icon: string; title: string; description: string; features: string[] }[];
}

export default function ThreeThingsSection() {
  const { data, loading, error, refresh } = useSiteContent<ThreeThingsData>('why_us_three_things');

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 text-center mb-12 md:mb-16">
            {data.title}{' '}
            <span className="text-primary-500">{data.highlight}</span>{' '}
            {data.titleEnd}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {data.items.map((item, idx) => (
              <div key={idx} className="relative">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-primary-500 text-lg`} />
                  </div>
                  <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-white text-sm" />
                  </div>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  {item.description}
                </p>
                <ul className="space-y-2">
                  {item.features.map((feature, fIdx) => (
                    <li key={fIdx} className="flex items-center gap-2 text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-line text-primary-500 text-xs" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}